import { render } from "./userDesclimberPopup.vue?vue&type=template&id=45f0da59&scoped=true&ts=true"
import script from "./userDesclimberPopup.vue?vue&type=script&lang=ts"
export * from "./userDesclimberPopup.vue?vue&type=script&lang=ts"

import "./userDesclimberPopup.vue?vue&type=style&index=0&id=45f0da59&scoped=true&lang=css"

import exportComponent from "/home/jstechno-26/projects/Barting-Coin/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45f0da59"]])

export default __exports__